@if (column?.styleConfig?.type === 'multi-tag') {

  <div class="multi-tag-container">
    <ng-container *ngIf="value?.length > 0">
      @for (item of getTagItems(); track $index) {
        <div [ngClass]="'tag_' + ($index + 1)" [ngStyle]="getTagStyles($index)">
          {{ formatCellValue(getLabelValue(item), 'STRING') }}
        </div>
      }
    </ng-container>
    <div *ngIf="value?.length > getMaxTagCount()"
         class="tag_count"
         [appTooltip]="getTooltipData()"
         [keyToPick]="getLabelKey()"
         position="bottom">
      + {{ value.length - getMaxTagCount() }}
    </div>
  </div>

} @else if (column?.styleConfig?.type === 'user-avatar') {
  <div class="user_badge">
    <div class="avatar_icon">{{ resolvedValue?.charAt(0) || "N/A" }}</div>
    {{ resolvedValue }}
  </div>

} @else if (column?.columnType === 'ACTION' && column?.styleConfig?.type === 'button') {
  @if (column.actionConfig.confirmationRequired) {
    <a nz-popconfirm
       [nzPopconfirmTitle]="column.actionConfig.confirmationMessage ?? 'Are you sure you want to perform this task?'"
       (nzOnConfirm)="handleButtonClick(column?.actionConfig)">
      <button [ngClass]="getCellClasses()" [ngStyle]="getCellStyles()"
              *ngIf="evaluateButtonVisibility(column?.actionConfig)">
        <app-svg-icon
          *ngIf="effectiveConfig?.icon"
          class="icon right-icon"
          [path]="effectiveConfig?.icon"
          [ngStyle]="getIconStyles()">
        </app-svg-icon>
        {{ column?.actionConfig?.label }}
      </button>
    </a>
  } @else {
    <button [ngClass]="getCellClasses()" [ngStyle]="getCellStyles()"
            *ngIf="evaluateButtonVisibility(column?.actionConfig)"
            (click)="handleButtonClick(column?.actionConfig); $event.stopPropagation()"
    >
      <app-svg-icon
        *ngIf="effectiveConfig?.icon"
        class="icon right-icon"
        [path]="effectiveConfig?.icon"
        [ngStyle]="getIconStyles()">
      </app-svg-icon>
      {{ column?.actionConfig?.label }}
    </button>
  }
} @else {

  <div class="cell" *ngIf="!column?.actionConfig || evaluateButtonVisibility(column.actionConfig)"
       [ngClass]="getCellClasses()" [ngStyle]="getCellStyles()" (click)="handleClickableElement()">
    <app-svg-icon
      *ngIf="effectiveConfig?.icon && effectiveConfig?.iconPosition === 'left'"
      class="icon left-icon"
      [path]="effectiveConfig?.icon"
      [ngStyle]="getIconStyles()">
    </app-svg-icon>

    <div class="content" [ngClass]="{editable_td: column.editable}">
      @if (column?.columnType === 'ACTION') {
        @if (resolvedValue) {
          <span>{{ resolvedValue }}</span>
        } @else {
          <span>{{ column?.actionConfig?.label }}</span>
        }
      } @else {
        <span>
            @if (column.editable) {
              {{ resolvedValue }}
            } @else {
              {{
                column.dataType === TableDataType.CURRENCY
                  ? CommonUtils.formatCurrency(resolvedValue)
                  : (resolvedValue || '-')
              }}
            }
        </span>
      }
    </div>

    <app-svg-icon
      *ngIf="effectiveConfig?.icon && effectiveConfig?.iconPosition === 'right'"
      class="icon right-icon"
      [path]="effectiveConfig?.icon"
      [style.background]="effectiveConfig.iconColor || effectiveConfig.color">
    </app-svg-icon>
  </div>

}


<!--} @else {
  <div *ngFor="let config of styleConfigForField" [ngClass]="config?.className" [ngStyle]="config?.style">
    <img *ngIf="config.iconPath" [src]="config?.iconPath" alt="icon">
    @if(record === config.value){
      {{ record }}
    }
  </div>
}-->
